// 院校查询、院校推荐条件数据
export const conditionsExt = {
  yxdq: [
    {
      name: "不限",
      value: 0,
      isActive: true
    },
    {
      name: "北京",
      value: "北京",
      isActive: false
    },
    {
      name: "天津",
      value: "天津",
      isActive: false
    },
    {
      name: "上海",
      value: "上海",
      isActive: false
    },
    {
      name: "江苏",
      value: "江苏",
      isActive: false
    },
    {
      name: "浙江",
      value: "浙江",
      isActive: false
    },
    {
      name: "广东",
      value: "广东",
      isActive: false
    },
    {
      name: "湖北",
      value: "湖北",
      isActive: false
    },
    {
      name: "湖南",
      value: "湖南",
      isActive: false
    },
    {
      name: "山东",
      value: "山东",
      isActive: false
    },
    {
      name: "福建",
      value: "福建",
      isActive: false
    },
    {
      name: "重庆",
      value: "重庆",
      isActive: false
    },
    {
      name: "四川",
      value: "四川",
      isActive: false
    },
    {
      name: "陕西",
      value: "陕西",
      isActive: false
    },
    {
      name: "云南",
      value: "云南",
      isActive: false
    },
    {
      name: "河北",
      value: "河北",
      isActive: false
    },
    {
      name: "山西",
      value: "山西",
      isActive: false
    },
    {
      name: "吉林",
      value: "吉林",
      isActive: false
    },
    {
      name: "黑龙江",
      value: "黑龙江",
      isActive: false
    },
    {
      name: "辽宁",
      value: "辽宁",
      isActive: false
    },
    {
      name: "安徽",
      value: "安徽",
      isActive: false
    },
    {
      name: "河南",
      value: "河南",
      isActive: false
    },
    {
      name: "江西",
      value: "江西",
      isActive: false
    },
    {
      name: "广西",
      value: "广西",
      isActive: false
    },
    {
      name: "贵州",
      value: "贵州",
      isActive: false
    },
    {
      name: "海南",
      value: "海南",
      isActive: false
    },
    {
      name: "宁夏",
      value: "宁夏",
      isActive: false
    },
    {
      name: "甘肃",
      value: "甘肃",
      isActive: false
    },
    {
      name: "青海",
      value: "青海",
      isActive: false
    },
    {
      name: "新疆",
      value: "新疆",
      isActive: false
    },
    {
      name: "内蒙古",
      value: "内蒙古",
      isActive: false
    },
    {
      name: "西藏",
      value: "西藏",
      isActive: false
    }
  ],
  pcType:[
    {
      name:"不限",
      value:0,
      isActive:true,
      isPxz:true
    },
    {
      name:"本科提前批",
      value:3,
      isActive:false,
      isBkTqpActive:true,
      isPxz:true,
      isHidden:true
    },
    {
      name:"本科提前批(非平行组)",
      value:2,
      isActive:false,
      isPxz:false
    },
    {
      name:"本科提前批(平行组)",
      value:3,
      isActive:false,
      isPxz:false
    },
    {
      name:"高职专科批",
      value:8,
      isActive:false,
      isBkTqpActive:false,
      isPxz:true
    }
  ],
  // pcType: [
  //   {
  //     name: "不限",
  //     value: 0,
  //     isActive: true,
  //     isPxz: true
  //   },
  //   {
  //     name: "本科提前批非平行组(按独立设置艺术院校招生政策)",
  //     value: 1,
  //     alias: "pc-type1",
  //     isActive: false,
  //     isPxz: false
  //   },
  //   {
  //     name: "本科提前批非平行组(其他院校)",
  //     value: 2,
  //     isActive: false,
  //     isPxz: false
  //   },
  //   {
  //     name: "本科提前批平行组院校",
  //     value: 3,
  //     isActive: false,
  //     isPxz: true
  //   },
  //   {
  //     name: "本科批非平行组院校",
  //     value: 4,
  //     isActive: false,
  //     isPxz: false
  //   },
  //   {
  //     name: "本科批平行组院校",
  //     value: 5,
  //     isActive: false,
  //     isPxz: true
  //   },
  //   {
  //     name: "高职专科批",
  //     value: 8,
  //     isActive: false,
  //     isPxz: true
  //   }
  // ],
  rkcj: [
    {
      name: "联考成绩",
      value: 0,
      isActive: true
    },
    {
      name: "校考成绩",
      value: 1,
      isActive: false
    }
  ],
  kl: [
    {
      name: "不限",
      value: 0,
      isActive: true
    },
    {
      name: "文科",
      value: "文科",
      isActive: false
    },
    {
      name: "理科",
      value: "理科",
      isActive: false
    },
    {
      name: "文理兼招",
      value: "文理兼招",
      isActive: false
    }
  ],
  yxType: [
    {
      name: "不限",
      value: 0,
      isActive: true
    },
    {
      name: "985",
      alias: "sf985",
      value: 1,
      isActive: false
    },
    {
      name: "211",
      alias: "sf211",
      value: 1,
      isActive: false
    },
    {
      name: "公办院校",
      alias: "sfgb",
      value: 1,
      isActive: false
    },
    {
      name: "民办院校",
      alias: "sfmb",
      value: 1,
      isActive: false
    }
  ],
  type: [
    {
      name: "冲刺型",
      value: 1,
      isActive: true
    },
    {
      name: "稳妥型",
      value: 2,
      isActive: false
    },
    {
      name: "保守型",
      value: 3,
      isActive: false
    }
  ],
  zxkms: [
    { name: "不限", value: "", isActive: true },
    { name: "政治", value: 1, isActive: false },
    { name: "地理", value: 2, isActive: false },
    { name: "化学", value: 3, isActive: false },
    { name: "生物", value: 4, isActive: false }
  ]
};
// 再选科目数据
export const zxkmList = [
  {text: '政治', value: 1},
  {text: '地理', value: 2},
  {text: '化学', value: 3},
  {text: '生物', value: 4},
];
